module.exports = {
	SEARCH_KEYWORDS: {
		GENRE: 'genre:',
		ARTIST: 'artist:',
		SONG: 'song:',
		ISRC: 'isrc:',
		ID: 'id:',
		TRACK_ID: 'track-id:',
		VARIIS_ID: 'variis-id:',
	},
	SEARCH_COLLECTIONS: {
		ALBUM: 'albums',
		ARTIST: 'artists',
		SONG: 'songs',
		PLAYLIST: 'playlists',
		SUGGESTED: 'suggested',
	},
	SEARCH_SONG_TABLE_SORTERS: {
		songs: [{ value: 'relevance', label: 'Relevance', default: true, overwriteDefault: true }],
		default: [
			{ value: 'name', label: 'Song' },
			{ value: 'artist', label: 'Artist' },
			{ value: 'genre', label: 'Genre' },
			{ value: 'duration', label: 'Length' },
			{ value: 'cleared_timestamp', label: 'Acquired Date', default: true },
			{ value: 'track_source', label: 'Track Source' },
		],
	},
	SEARCH_SUGGESTIONS_COLLECTIONS: {
		ALBUM: 'albums',
		ARTIST: 'artists',
		SONG: 'songs',
		PLAYLIST: 'playlists',
		RECENT: 'recent',
	},
	SEARCH_SUGGESTIONS_LIMIT: 3,
	SEARCH_ENGINE_CHARACTERS_MAPPING: ['&=>and', '-n-=>and', '$=>s', '@=>a', '!=>i'],
	SEARCH_SONG_TABLE_CUSTOM_COLUMNS: [
		{
			columnHeader: 'TRACK SOURCE',
			fixedWidth: '15%',
			songProperty: 'track_source',
		},
		{
			columnHeader: 'ACQUIRED DATE',
			headerClassName: 'text-center',
			fixedWidth: '15%',
			songProperty: 'cleared_timestamp',
			cellContentClassName: 'text-center',
		},
	],
};
